import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Home from "./components/Home/Home";
import './App.css'
import Footer from "./components/Footer/Footer";
import About from "./components/About/About";
import ProjectDetails from "./components/Project/ProjectPage";
import Project from "./components/Project/Project";
import ScrollToTop from "./components/ScrollToTop";
import Gallery from "./components/Gallery/Gallery";
import Contact from "./components/Contact/Contact";
import WhatsappFloat from "./components/WhatsappFloat";

function App() {
  return (
    <Router>
      <ScrollToTop/>
     <Navbar/>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/about-us" element={<About/>}/>
        <Route path="/project" element={<Project/>}/>
           <Route path="/projects/:id" element={<ProjectDetails />} />
           <Route path="/gallery" element={<Gallery/>}/>
           <Route path="/contact-us" element={<Contact/>}/>
      </Routes>
      <Footer/>
      <WhatsappFloat/>
    </Router>
  );
}

export default App;
